// tracking.js
import { getConfig } from './../loadconfig'; // Adjust the import path as needed

const trackPage = (pageName,languageData) => {
    let config = getConfig();    

    if (window != 'undefined' && window.gtag) {

        window.gtag('config', config.GATRACKID, {
        page_path: `${window.location.pathname}/${languageData}/${pageName}`,
        page_title: document.title
        });
  }
};

export default trackPage;